import { createNews, deleteNews, getNewsById, getNewsList, updateNews } from "services/newsApi"
import { RequestAgentNewsInput, RequestInputCreateNews, RequestInputDeleteNews, RequestInputUpdateNews, ResponseAgentNewsById, ResponseAgentNewsList, ResponseCreateNews, ResponseDeleteNews } from "services/interface/news/news.interface"
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from "@tanstack/react-query"


export const useGetNewsList = (input: RequestAgentNewsInput): UseQueryResult<ResponseAgentNewsList, Error> => {
    return useQuery<ResponseAgentNewsList, Error>({
        queryKey: ['newsList', input.id, input.ref_id, input.search, input.offset, input.limit, input.search, input.is_approve],
        queryFn: () => getNewsList(input),
    })
}

export const useGetNewsById = (newsId: string): UseQueryResult<ResponseAgentNewsById, Error> => {
return useQuery<ResponseAgentNewsById, Error>({
    queryKey: ["newsById", newsId],
    queryFn: () => getNewsById(newsId),
});
};

export const useCreateNews = (): UseMutationResult<
  ResponseCreateNews,
  Error,
  RequestInputCreateNews,
  unknown
> => {
  return useMutation<ResponseCreateNews, Error, RequestInputCreateNews, unknown>({
    mutationFn: (input: RequestInputCreateNews): Promise<ResponseCreateNews> => createNews(input),
  });
};

export const useUpdateNews = (): UseMutationResult<
  ResponseCreateNews,
  Error,
  RequestInputUpdateNews,
  unknown
> => {
  return useMutation<ResponseCreateNews, Error, RequestInputUpdateNews, unknown>({
    mutationFn: (input: RequestInputUpdateNews): Promise<ResponseCreateNews> => updateNews(input),
  });
};

export const useDeleteNews = (): UseMutationResult<
  ResponseDeleteNews,
  Error,
  RequestInputDeleteNews,
  unknown
> => {
  return useMutation<ResponseDeleteNews, Error, RequestInputDeleteNews, unknown>({
    mutationFn: (input: RequestInputDeleteNews): Promise<ResponseDeleteNews> => deleteNews(input),
  });
};